import React, { useState, useEffect } from 'react';

import AOS from 'aos';

import { steps } from '../../data/main';

import styles from './step_slide.module.css';

const StepSlide = () => {
  const [activeIndex, setActiveIndex] = useState(1);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  });

  return (
    <div className={styles.stepSlide}>
      <div data-aos='fade-up' className={styles.textBox}>
        <div className={styles.fixText}>
          유연하게 연동되는 <br />
          키오스크, 포스, 모바일로 <br />
          매장관리를 해보세요
        </div>
        <div className={styles.stepTextBox}>
          {steps.map((step, index) => {
            return (
              <div
                className={
                  activeIndex === index + 1
                    ? [styles.stepText, styles.active].join(' ')
                    : styles.stepText
                }
                key={index}
              >
                <span className={styles.step}>STEP 0{index + 1}</span>
                <h2 className={styles.title}>{step.title}</h2>
                <p className={styles.desc}>{step.description}</p>
              </div>
            );
          })}
        </div>
        <div className={styles.pages}>
          {[1, 2, 3, 4, 5].map((index) => {
            return (
              <span
                key={index}
                className={
                  activeIndex === index
                    ? [styles.activePage, styles.page].join(' ')
                    : styles.page
                }
                onMouseOver={() => setActiveIndex(index)}
                onClick={() => setActiveIndex(index)}
              >
                {index}
              </span>
            );
          })}
        </div>
      </div>
      <div data-aos='fade-up' data-aos-offset={400} className={styles.imgBox}>
        {[1, 2, 3, 4, 5].map((index) => (
          <img
            key={index}
            className={
              activeIndex === index
                ? [styles.img, styles.active].join(' ')
                : styles.img
            }
            src={process.env.PUBLIC_URL + `/imgs/main/step/${index}.png`}
            alt={activeIndex}
          />
        ))}
      </div>
      <div className={styles.mobileText}>
        유연하게 연동되는 <br />
        키오스크, 포스, 모바일로 <br />
        매장관리를 해보세요
      </div>
    </div>
  );
};

export default StepSlide;
